export const TOGGLE_DISCOUNT = 'TOGGLE_DISCOUNT'
export const toggleDiscount = () => ({
  type: TOGGLE_DISCOUNT,
})
